import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../shared';

@Injectable({
  providedIn: 'root'
})
export class ChartOfAccountService extends BaseApiTemplateService<any> {

  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'chart-of-acc';
    this.httpClient = http;
  }
}
